// Define the 3 predefined service names with their specific options
export const PREDEFINED_SERVICE_CONFIGS = {
  Overview: [
    {
      key: "about",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "Company about section and basic information",
      category: "information",
      displayOrder: 1,
    },
    {
      key: "management",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "Management team and leadership information",
      category: "information",
      displayOrder: 2,
    },
    {
      key: "financials_overview",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "Financial overview and key metrics",
      category: "financial",
      displayOrder: 3,
    },
    {
      key: "key_milestones",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "Key company milestones and achievements",
      category: "information",
      displayOrder: 4,
    },
    {
      key: "key",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "Key company information and highlights",
      category: "information",
      displayOrder: 5,
    },
  ],
  "Brand & Trust": [
    {
      key: "online_presence",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "Online presence and digital footprint analysis",
      category: "brand",
      displayOrder: 1,
    },
    {
      key: "news",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "News coverage and media mentions",
      category: "brand",
      displayOrder: 2,
    },
    {
      key: "client_reviews",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "Client reviews and testimonials",
      category: "brand",
      displayOrder: 3,
    },
    {
      key: "employee_reviews",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "Employee reviews and workplace ratings",
      category: "brand",
      displayOrder: 4,
    },
    {
      key: "linkedin_timeline",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "LinkedIn timeline and professional activity",
      category: "brand",
      displayOrder: 5,
    },
  ],
  Opportunities: [
    {
      key: "growth_opportunities",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "Growth opportunities and market potential",
      category: "opportunities",
      displayOrder: 1,
    },
    {
      key: "tailwinds_headwinds",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "Tailwinds and headwinds affecting the business",
      category: "opportunities",
      displayOrder: 2,
    },
    {
      key: "ma_opportunities",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "M&A opportunities and strategic fit",
      category: "opportunities",
      displayOrder: 3,
    },
  ],
  "Competitive Landscape": [
    {
      key: "overview",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "Online presence and digital footprint analysis",
      category: "competitive_landscape",
      displayOrder: 1,
    },
    {
      key: "competitor_map",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "News coverage and media mentions",
      category: "competitive_landscape",
      displayOrder: 2,
    },
    {
      key: "key_competitors",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "Client reviews and testimonials",
      category: "competitive_landscape",
      displayOrder: 3,
    },
  ],
  Shareholders: [
    {
      key: "ownership",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "Ownership structure and major shareholders",
      category: "shareholders",
      displayOrder: 1,
    },
    {
      key: "previous_owners",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "Previous owners and historical ownership changes",
      category: "shareholders",
      displayOrder: 2,
    },
    {
      key: "major_shareholders",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "Major shareholders and their influence",
      category: "shareholders",
      displayOrder: 2,
    },
  ],
  "Risk Scorecard": [],
  "Credit Analysis": [
    {
      key: "basic_corporate_details",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "Basic corporate details and registration information",
      category: "Credit Analysis",
      displayOrder: 1,
    },
    {
      key: "financial_profile",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "Financial statements and performance metrics",
      category: "Credit Analysis",
      displayOrder: 2,
    },
    {
      key: "credit_risk_specific_data",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "Credit risk-specific data and indicators",
      category: "Credit Analysis",
      displayOrder: 3,
    },
    {
      key: "portfolio_review_management_information",

      value: "enabled",
      valueType: "BOOLEAN" as const,

      isRequired: true,
      isActive: true,
      description: "Portfolio review and management information",
      category: "Credit Analysis",
      displayOrder: 4,
    },
    {
      key: "product_level_information",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "Product-level information and offerings",
      category: "Credit Analysis",
      displayOrder: 5,
    },
    {
      key: "credit_assessment_data",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description:
        "Credit assessment data including risk pillars and scorecards",
      category: "Credit Analysis",
      displayOrder: 6,
    },
    {
      key: "additional_data",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "Additional data and value-added information",
      category: "Credit Analysis",
      displayOrder: 7,
    },
    {
      key: "esg_analysis",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "Environmental, Social, and Governance (ESG) analysis",
      category: "Credit Analysis",
      displayOrder: 8,
    },
  ],
  "KYC & KYB": [
    {
      key: "kyc_kyb_report",
      value: "enabled",
      valueType: "BOOLEAN" as const,
      isRequired: true,
      isActive: true,
      description: "KYC & KYB report and verification details",
      category: "KYC & KYB",
      displayOrder: 1,
    },
  ],
  'Bank Risk Score': [
    {
      key: 'bank_risk_score_report',
      value: 'enabled',
      valueType: 'BOOLEAN' as const,
      isRequired: true,
      isActive: true,
      description: 'Bank risk score report and analysis',
      category: 'Bank Risk Score',
      displayOrder: 1,
    },
  ],
  'Risk Parameters': [
    {
      key: 'risk_parameters_report',
      value: 'enabled',
      valueType: 'BOOLEAN' as const,
      isRequired: true,
      isActive: true,
      description: 'Risk parameters report and analysis',
      category: 'Risk Parameters',
      displayOrder: 1,
    },
  ],
};

export const PREDEFINED_SERVICE_NAMES = Object.keys(PREDEFINED_SERVICE_CONFIGS);
